// import React from 'react'
// import NavDropdown from 'react-bootstrap/NavDropdown';
// import { Link, navigate, useNavigate } from 'react-router-dom';
// import { Col, Container, Dropdown, Nav, Navbar, Row } from 'react-bootstrap';
// import logo1 from '../Assets/logonew.png'
// const DeliveryNav = () => {

//   const navigate = useNavigate();

//   const logoutFun = () => {
//     sessionStorage.clear();
//     navigate('/deliveryLogin')
//   }
//   const handlePasswordChange = () => {
//     navigate('/passChangeDelivery');
//   };

//   const userdata = JSON.parse(sessionStorage.getItem('userdata'));
//     const branchId = userdata.branch_id;
//     const empName = userdata.employee_name;
//     const Name = userdata ? userdata.branch_name : '';
//   return (
// <Container fluid>
//     <Row  className='py-2 m-0 p-0' >
//         <Col sm={12} md={3} style={{display:"flex",alignItems: "center",justifyContent:"center"}}>
//         <img src={logo1} alt="Logo" style={{mixBlendMode:"darken"}} width={120} height={80} />
//         </Col>

//         <Col sm={12} md={6} className='pt-2' style={{ display: "flex", alignItems: "center",justifyContent:"center" }}> 
//         <h2 style={{fontFamily:"initial"}}><b>{Name}</b></h2>
//         </Col>

//         <Col sm={12} md={3} className='pt-2' style={{ display: "flex", alignItems: "center",justifyContent:"center" }}>
//             {/* <Nav.Link className='px-2 py-1' style={{border:"1px solid #3d3d3d",borderRadius:"5px"}}><b><i class="fa-solid fa-user" title={user.name}></i>&nbsp;&nbsp;</b>{user.name}</Nav.Link> */}
//             <Nav>
//               <Dropdown>
//                 <Dropdown.Toggle className='px-2 py-1' style={{ border: "1px solid #3d3d3d", borderRadius: "5px", backgroundColor: "transparent", color: "blue" }}>
//                   <b><i className="fa-solid fa-user" title={userdata.employee_name}></i>&nbsp;&nbsp;</b>{userdata.employee_name}
//                 </Dropdown.Toggle>

//                 <Dropdown.Menu>
//                   <Dropdown.Item className='navName' onClick={handlePasswordChange}>Change Password</Dropdown.Item>
//                   <Dropdown.Item className='fs-md-5 navName' onClick={logoutFun}>Log-Out &nbsp;&nbsp;<i class="fa-solid fa-right-from-bracket" style={{color:"rgb(254, 105, 129)"}}></i></Dropdown.Item>
//                 </Dropdown.Menu>
//               </Dropdown>
//             </Nav>
//           </Col>
//     </Row>
//     </Container>

//   )
// }

// export default DeliveryNav





import React from 'react'
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Link, navigate, useNavigate } from 'react-router-dom';
import { Col, Container, Dropdown, Nav, Navbar, Row } from 'react-bootstrap';
import logo1 from '../Assets/logonew.png'
import { Popover, Typography } from '@mui/material';
import { FaUserCircle } from "react-icons/fa";
import { AiOutlineLogout } from "react-icons/ai";
import { RiLockPasswordFill } from "react-icons/ri";
import '../AdminComponent/Master.css'
const DeliveryNav = () => {

  const userdata = JSON.parse(sessionStorage.getItem('userdata'));
  const branchId = userdata.branch_id;
  const empName = userdata.employee_name;
  const Name = userdata ? userdata.branch_name : '';

  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClickPopover = (event) => {
     setAnchorEl(event.currentTarget);
   };
   const handleClosePopover = () => {
     setAnchorEl(null);
   };
   const open2 = Boolean(anchorEl);
   const id = open2 ? 'simple-popover' : undefined;

  const navigate = useNavigate();

  const logoutFun = () => {
    sessionStorage.clear();
    navigate('/deliveryLogin')
  }
  const handlePasswordChange = () => {
    navigate('/passChangeDelivery');
  };
  const handleDashboard = () => {
    navigate('/deliveryDashboard');
  };

  return (
<Container >
    {/* <Row  className='py-2 m-0 p-0' >
        <Col sm={12} md={3} style={{display:"flex",alignItems: "center",justifyContent:"center"}}>
        <img src={logo1} alt="Logo" style={{mixBlendMode:"darken"}} width={120} height={80} />
        </Col>

        <Col sm={12} md={6} className='pt-2' style={{ display: "flex", alignItems: "center",justifyContent:"center" }}> 
        <h2 style={{fontFamily:"initial"}}><b>{Name}</b></h2>
        </Col>

        <Col sm={12} md={3} className='pt-2' style={{ display: "flex", alignItems: "center",justifyContent:"center" }}>
            <Nav>
              <Dropdown>
                <Dropdown.Toggle className='px-2 py-1' style={{ border: "1px solid #3d3d3d", borderRadius: "5px", backgroundColor: "transparent", color: "blue" }}>
                  <b><i className="fa-solid fa-user" title={userdata.employee_name}></i>&nbsp;&nbsp;</b>{userdata.employee_name}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item className='navName' onClick={handlePasswordChange}>Change Password</Dropdown.Item>
                  <Dropdown.Item className='fs-md-5 navName' onClick={logoutFun}>Log-Out &nbsp;&nbsp;<i class="fa-solid fa-right-from-bracket" style={{color:"rgb(254, 105, 129)"}}></i></Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Nav>
          </Col>
    </Row> */}

    <Row className=' py-1 mt-3 shadow m-0 p-0 px-md-3' style={{display:"flex",flexDirection:"row",backgroundColor:"white ", borderRadius:"5px "}} >
        <Col  style={{display:"flex",alignItems: "center",justifyContent:"start"}}>
        <img src={logo1} alt="Logo" style={{mixBlendMode:"darken"}} width={70} height={50} />
        </Col>

        <Col className='text-center' style={{ display: "flex", alignItems: "center",justifyContent:"center" }}> 
        <h2 style={{fontFamily:"sans-serif",color:" rgb(47, 79, 79)"}}>{Name}</h2>
        </Col>

         <Col style={{ display: "flex", alignItems: "center",justifyContent:"end" }}>
          <FaUserCircle  style={{ fontSize: 30 ,color:"rgb(47, 79, 79)"}} title={userdata.employee_name} aria-describedby={id} variant="contained" onClick={handleClickPopover} />
          <Popover
          
              id={id}
              open={open2}
              anchorEl={anchorEl}
              onClose={handleClosePopover}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
            >
              <Typography> <button className='profileButton' onClick={handleDashboard}>Dashboard &nbsp; <i className='fa fa-line-chart'></i></button> </Typography>
              <Typography> <button className='profileButton' onClick={handlePasswordChange}>Change Password &nbsp; <RiLockPasswordFill /></button> </Typography>
              <Typography> <button className='profileButton' onClick={logoutFun}>Logout &nbsp;<AiOutlineLogout /></button> </Typography>
            </Popover>
            </Col>
            </Row>
    </Container>

  )
}

export default DeliveryNav
